export { default } from './BlockQuoteCard'
